let vibe_cake_masters_add_to_cart_dropdown = ( function ( $ ) {

	let cart       = require( './add-to-cart' ),
		loading    = require( './loading' ),
		anim_speed = 400;

	let _init = function() {
		let $wrap = $( '.course-add-to-cart-wrap' );

		if ( $wrap.length > 0 ) {
			$wrap.find( '.add-to-cart-dropdown-toggle' ).on( 'click', _toggle_dropdown );
			$wrap.find( '.course-add-selection-to-cart' ).on( 'click', _maybe_add_selection_to_cart );
			$wrap.find( 'input[type="radio"]' ).on( 'change', _change_purchase_type );

			$wrap.on( 'masters-cart-course_add_item_success', _handle_success );
			$wrap.on( 'masters-cart-course_add_to_cart_error', _handle_failure );

			_maybe_enable_button( $wrap.find( '.add-to-cart-dropdown' ) );
		}
	};

	let _toggle_dropdown = function( e ) {
		e.preventDefault();

		let $dropdown = $( this ).next( '.add-to-cart-dropdown' );

		if ( $dropdown.hasClass( 'animating' ) ) {
			return;
		}

		$dropdown.addClass( 'animating' );

		if ( $dropdown.hasClass( 'open' ) ) {
			_close_dropdown( $dropdown );
		} else {
			_open_dropdown( $dropdown );
		}

		setTimeout( () => {
			$dropdown.removeClass( 'animating' );
		}, anim_speed );
	};

	let _open_dropdown = function( $dropdown ) {
		$dropdown.removeClass( 'closed' );
		$dropdown.addClass( 'open' );
		$dropdown.slideDown( anim_speed );
	};

	let _close_dropdown = function( $dropdown ) {
		$dropdown.removeClass( 'open' );
		$dropdown.addClass( 'closed' );
		$dropdown.slideUp( anim_speed );
	};

	let _maybe_add_selection_to_cart = function( e ) {
		let $dropdown = $( this ).closest( '.add-to-cart-dropdown' );

		$dropdown.find( '.inner' ).loading();

		let $radio = $dropdown.find( 'input[type="radio"]:checked' );

		if ( $radio.length > 0 ) {
			let add_subscription  = $radio.val() === 'installments',
				clear_cart_before = $dropdown.data('clear-cart-before') ?? false;

			cart.add_to_cart( $dropdown.data( 'course' ), 'course', $dropdown.closest( '.course-add-to-cart-wrap' ), add_subscription, false, clear_cart_before );
		}
	};

	let _change_purchase_type = function ( e ) {
		_maybe_enable_button( $( this ).closest( '.add-to-cart-dropdown' ) );
	};

	let _maybe_enable_button = function( $dropdown ) {
		let $radio = $dropdown.find( 'input[type="radio"]:checked' );

		if ( $radio.length > 0 ) {
			$dropdown.find( '.course-add-selection-to-cart' ).removeClass( 'disabled' );
		} else {
			$dropdown.find( '.course-add-selection-to-cart' ).addClass( 'disabled' );
		}
	};

	let _handle_success = function ( e, response ) {
		let $wrap = $( '.course-add-to-cart-wrap[data-course="'+ response.course_id +'"]' );

		$wrap.replaceWith( response.new_button_html );
	};

	let _handle_failure = function ( e, response ) {
		let $wrap = $( '.course-add-to-cart-wrap[data-course="'+ response.course_id +'"]' );

		$wrap.find( '.inner' ).loaded();
	};

	$( document ).ready( _init );

} )( jQuery );

module.exports = vibe_cake_masters_add_to_cart_dropdown;